import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReactIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-11.5 -10.23174 23 20.46348",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "React Logo" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 0,
			cy: 0,
			r: 2.05
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#61dafb",
			strokeWidth: 1,
			fill: "none",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					rx: 11,
					ry: 4.2
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					rx: 11,
					ry: 4.2,
					transform: "rotate(60)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					rx: 11,
					ry: 4.2,
					transform: "rotate(120)"
				})
			]
		})
	]
});
export default SvgReactIcon;
